import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import LoginPage from "./Pages/Auth/Login";
import RtlLayout from "layouts/rtl";

// A wrapper for protected routes
const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("authToken");
  return token ? children : <Navigate to="/auth/login" replace />;
};

const App = () => {
  return (
    <Provider store={store}>
      <Routes>
        {/* Public routes */}
        <Route path="auth/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="rtl/*"
          element={
            <ProtectedRoute>
              <RtlLayout />
            </ProtectedRoute>
          }
        />

        {/* Redirect to /admin if authenticated, else to login */}
        <Route path="/" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Provider>
  );
};

export default App;
